import { getContextHierarchyItems } from './utils'
import { type OsContextValue } from '@wppopen/react'
import { type GtmEventSchema } from './types'
import { createEventData } from './createEventData'

interface NavigationFields {
  pageUrl: string
  pageTitle: string
  previousUrl: string
}

/**
 *
 * @param osContext - The osContext object from the WPP Open React library.
 * @description This function maps the user details from the osContext to a data layer format for virtual page view events.
 * @returns
 */
export const getVirtualPageViewEventDataObject = (
  osContext: OsContextValue | null,
  navigationFields: NavigationFields,
) => {
  const contextObject = osContext?.osContext
  const hierarchyItems = getContextHierarchyItems(osContext)

  return createEventData('virtual_page_view', osContext, {
    context_type: osContext ? 'os' : 'unknown',
    project: contextObject?.project?.name || undefined,
    tenant_name: contextObject?.tenant?.name || undefined,
    ...hierarchyItems,
    ...navigationFields,
  }) satisfies GtmEventSchema
}
